import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#A37831",
    "col2d": "#4F2E0D",
    "col2n": "#794D32",
    "col2s": "#25201B"
}
function PlaInd033({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M0 403.85l2.15-2.35h412.4l2.15 2.35V0H0v403.85M66.15 137.5h.35v.2l-.35-.2z"
                    id="PlaInd033__Symbol_3_0_Layer0_0_FILL"
                />
                <path
                    fill="url(#PlaInd033__Gradient_1)"
                    d="M52.7 195.75v107.7h262.35v-107.7H52.7z"
                    id="PlaInd033__Layer7_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M123.9 252.15l3.35-3.35v-50.05h162.2v50.05l3.35 3.35v15.75l123.9 135.95V0H0v403.85L123.9 267.9v-15.75M66.15 137.5h.35v.2l-.35-.2z"
                    id="PlaInd033__Symbol_4_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M309.9 223.5l-17.95-12.75v37.05h9.4v-24.3h8.55M55.1 260.1q2.85 2.7 11.4 0-4.5 18.4 0 31.9h12.6v-48.9l-24 17m-.05-59.75q3.3 2.05 5.8 3.5v1.45q2.6 1 4.65 1.75-10.65 18.55 1 32.9h12.6v-49.2l-24.05 9.6M123.9 256v-3.85L0 375.95v7.4L123.9 256m-11.55-35.2v2.7q.95 2.15 1.7 3.6-3.1 10.35 1.3 20.7h9.4v-37.05L110.6 220.8h1.75M107 179.7q2.75 2.85 4.15 3.85 1.6 2.4 2.8 4.15-2.8 10.4 1.4 21h9.4v-36.05L107 179.7m4.05 0h.05v.1q-.002-.052-.05-.1m-23.9-37.4q17.8 3.05 26.55 3.95-4.35 12.2 1.65 24.15h9.4v-35.3l-37.6 4.25q-2.15 1.5 0 2.95m37.6-9.3V99.2q-21.4-2.35-37.6 0-2.25 1.5 0 3l6.2.7v1l2.45.2q13.3 1 19.35 1.45-10.85 13.3.2 27.45h9.4m-93.9 17.4h.85q22.8-.35 34.25-.55-16.8 21.3.55 38.25h12.6v-47.9l-48.25 5.4q-5.4 2.85 0 4.8m35.6-1.2q-1.2-.05-2.45-.05l2.5-.05q-.05.05-.05.1m-35.6-56.9q-4.4 2.15 0 3.7 27.15 4.65 35.65 5.75-6.2 18 0 35.95l12.4.25.2-.05V92.3q-25.05-1.8-48.25 0M79.1 42.95V0H65.8l.7.4q-9.85 16.4 0 37.25l12.6 5.3m0 2.6q-21.55-3.65-36.6 0l2.9 1q-6.3 3.4 21.1 41.55l12.6 2V45.55M97.55 64.6l7.1 2.45q-8.3.65 10.7 28.75l9.4 1.45V64.6q-16.45-3.1-27.2 0m8.15-41.5l2.35 1.35v.6q-9.05-3.1 7.3 33.25l9.4 4V23.1q-11.15-2.45-19.05 0m19.05-2.55V0h-9.4q-5.55 6.05 0 13.65l9.4 6.9m194.4 162.9l-27.2-10.8v36.05h9.4q28.8-22.1 14.35-25.25h3.45m-29.7 8.85v-1.4h-162.2v1.4h162.2m-79.85-42.05v3h79.85v-3q-40.7-9.35-79.85 0m-2.05 3v-3q-40.15-13.05-80.3 0v3h80.3m0 35v-3.75q-40.15-9.85-80.3 0v3.75h80.3m2.05-3.75v3.75h79.85v-3.75q-41-11.3-79.85 0m0-68.4v2.15h79.85v-2.15q-40.3-11.1-79.85 0m-2.05 2.15v-2.15q-41.4-11.05-80.3 0v2.15h80.3M312.3 67l6.85-2.4q-8.05-3.85-27.2 0v32.65l9.4-1.45q9.2-14.3 5.15-19.9.1-.15.2-.25 1.35-1.45 5.6-7.9V67m-10.95-53.35q4.25-6.8 0-13.65h-9.4v20.55l9.4-6.9M311 23.1q-8.05-2.2-19.05 0v39.2l9.4-4q11.95-33.05 4.05-30.75v-1.2l5.6-3.25m105.7 360.25v-7.4l-123.9-123.8V256l123.9 127.35M337.6 292h12.6q16.75-23.3 13.95-29.45h.95l-27.5-19.45V292m0-52.05h12.6q23.15-35.55 9.05-39.4h2.9l-24.55-9.8v49.2m0-51.85h12.6q42.6-30.9 35.5-39h.15q1.55-1.95 0-3.5l-48.25-5.4v47.9m-8.05-85.9q2.5-1.75 0-3-15.05-1.85-37.6 0V133h9.4q28-24.8 27-30.65l1.2-.15m-5.1 37.4l1.15-.7-33.65-3.8v35.3h9.4q32.75-27.3 23.1-30.8m61.4-43.6q2.6-2.1 0-3.7-22.4-1.6-48.25 0v45.6l.2.05 12.4-.25v-.2q22.6-23.8 25.6-34 4.25-3 10.05-7.5m-48.25-5.9l12.6-2q17.2-18.7 10.9-27.85 4.4-3.45 13.1-14.7-15.9-2.65-36.6 0V90.1m12.6-52.45q4.5-18.6 0-37.25l.7-.4h-13.3v42.95l12.6-5.3z"
                    id="PlaInd033__Symbol_10_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2s}
                    d="M79.1 292H66.5Q28.25 317.75 0 352.2v16.45L79.1 292m0-52.05H66.5Q27.7 251.6 0 282.05v12.1l79.1-54.2m36.25 7.85q-20.25 10.4-32.9 29.75v11.25l42.3-41h-9.4m0-39.1q-20.85 5.45-32.9 21.05v7.95l42.3-29h-9.4m0-38.3q-17.6.25-32.9 11.9v4.5l42.3-16.4h-9.4m-32.9-34.35v1.45l42.3-4.5h-9.4q-17.4-4.55-32.9 3.05m4.7 6.25v-2.95l-4.7.5v1.85h1.05q.1.3.5.75.7.85 1.65.85.55 0 .8-.4.15-.25.2-.55l.5-.05m0-40.1v-3h37.6l-42.3-6.4v8.8l4.7.6m-8.1 85.9H66.5q-36.05-.75-66.5 24v6.65l79.05-30.65m-48.3-36.7h.1v-5.8L0 149.1v4.95h.9q.05.2.2.4.3.4.75.35h3.4q6.4-1.05 14.4-1.35l6.2-.05q3.3-.05 4.25-.5.65-.3.65-1.2v-.3m48.15-13.45l-12.4-.25-.35-.2Q32.3 133.05 0 143.6v2.75l78.9-8.4M9.05 95.55q3.6 1.15 7.45 2.15h7q6.65-.35 7.05-1.7h.3v-3.7H79.1L0 80.3v12.3l2.35.25q1.4 1.05 6.7 2.7m33.45-50h36.6L0 12.6v19.45h1.6q.15.55.95.8 1.85.6 2.3.85 2.35 1.2 3.65 2.35 1.7 1.45 7.75 4.5 3.4 1.65 8.55 3.2Q32.5 46 38.9 46q1.9 0 2.5-.35.2-.1.3-.35l.8.25M94.15 64.8q1.25-.2 2.75-.4l.65.2h27.2L82.45 47v12.4l.85.3q.15 1.15 2.75 3.3 3.15 2.6 5.5 1.8h2.6m9.55-42q.8 0 1.3-.1l.7.4h19.05L92.5 0H82.45v9.65l1.15.7q-.15.2-.15.6 0 .85 1.7 2.4v.55l1.5.9h.25q2.05 1.6 3.8 2.35.3.15 5.95 2.9 5.8 2.75 7.05 2.75M207.55 162v-6.75h-80.3V162q39.15 7.25 80.3 0m2.05-6.75V162q41.55 11.05 79.85 0v-6.75H209.6M207.55 128v-7.75h-80.3V128q40.95 10.15 80.3 0m2.05-7.75V128q39.95 9.15 79.85 0v-7.75H209.6m-2.05-58.75v-10h-80.3v10q41.45 9.55 80.3 0m0 33.55V86h-80.3v9.1q1.3.35 2.55.7 38.9 12.35 77.75-.75m0-64.95V18.25h-80.3V30.1q42.15 12.5 80.3 0m81.9 64.9v-9H209.6v9.05q39.95 15.7 79.85-.05m0-33.5v-10H209.6v10q41.55 15.5 79.85 0m0-31.4V18.25H209.6V30.1q40.7 13.85 79.85 0M350.2 292h-12.6l36.1 35 .15.1 42.85 41.55V352.2q-28.5-41.8-66.5-60.2m-15.95-3.2v-11.25q-5.95-28.75-32.9-29.75h-9.4l42.3 41m0-51.1v-7.95q-4.35-17.8-32.9-21.05h-9.4l42.3 29m82.45 56.45v-12.1q-24.95-41.3-66.5-42.1h-12.6l79.1 54.2M386.6 149.1q.95 1.4 5.6 2.9 5.6 1.8 7.9 1.3h6.7q1.9-.35 6.95-.7 2.1-.15 2.1-1.2v-.2h.85v-2.1l-30.85-3.5v3.5h.75m-36.4 39h-12.55l79.05 30.65v-6.65q-29.35-25.5-66.5-24m-15.95-1.3v-4.5q-14.25-15.2-32.9-11.9h-9.4l42.3 16.4m15.95-49.1l-12.4.25 78.9 8.4v-2.75q-31.25-8.4-66.15-6.1h-.35v.2m-20.65-35.5l4.7-.6v-8.8l-42.3 6.4h37.6v3m4.7 35.3v-1.45q-15.3-6.5-32.9-3.05h-9.4l42.3 4.5m-.7-77.85l.7-.25V47l-42.3 17.6h27.2l1.55-.5h3.35q2.65 0 6.05-1.45 3.45-1.5 3.45-2.8v-.2m.7-50V0H324.2L292 23.1h19l.65-.35q.2.05.5.05 1.6 0 7.35-1.55 6.8-1.85 8.1-3.5.3-.4 3.35-3.75 2.3-2.7 2.8-4.05l.5-.3M416.7 94.9V80.3l-79.1 12h48.25V96h.25q-.15.2-.15.5 0 .85 1.15 1 .9.1 5.2.5h8.6q2.9-.35 9.75-1.05 4.85-.7 5.35-2l.7-.05M415 31.5l1.7-.6V12.6l-79.1 32.95h36.6l2.25-.75q.3.15.75.1h3.9q5.35-1.45 9.8-2.4 1.65-.35 6.8-1.1 4.35-.65 5.7-1.1 1.15-.4 4.75-1.4 3.3-1.05 4.75-2.45.8-.8 2.1-4.95z"
                    id="PlaInd033__Symbol_11_0_Layer0_0_FILL"
                />
                <path
                    fillOpacity={0.502}
                    d="M273.6-3.2H111.4v198.95h162.2V-3.2z"
                    id="PlaInd033__Layer2_0_FILL"
                />
                <path
                    fill="#25201B"
                    d="M193.75 155v4q41.526 11.037 79.85 0v-4h-79.85m-2.05 4v-4h-80.3v4q39.171 7.238 80.3 0m2.05-36.75V125q39.925 9.17 79.85 0v-2.75h-79.85M191.7 125v-2.75h-80.3V125q40.945 10.13 80.3 0m0-32.95v-1.8h-80.3v1.8q40.933 11.947 80.3 0m81.9-.05v-1.75h-79.85v1.8q39.925 15.712 79.85-.05z"
                    id="PlaInd033__Layer2_1_FILL"
                />
                <linearGradient
                    id="PlaInd033__Gradient_1"
                    gradientUnits="userSpaceOnUse"
                    x1={183.85}
                    y1={300.75}
                    x2={183.85}
                    y2={198.25}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopOpacity={0} />
                    <stop offset="100%" stopOpacity={0.6} />
                </linearGradient>
                <g id="PlaInd033__Layer1_0_FILL">
                    <path
                        fill="#9DB69E"
                        d="M285.5 220.5v24.3l3.15 2.85v-24.8l-3.15-2.35z"
                    />
                    <path
                        fill="#999"
                        d="M318.4 245.15l-4-3v28.75l4 3.65v-29.4m-294.5-50.4v-40.5l-4.9.85v41.4l4.9-1.75m75.6-55.45l-3.9.55v28.95l3.9-1.4v-28.1m-112-49.35l-3.35-.35v51l3.35-.3V89.95m58.75 7.7l-4.75-.45v38.1l4.75-.45v-37.2m-17.5-3.2l-4.85-.5v43l4.85-.45V94.45m-23-.1L.5 93.8v45.3l5.25-.5V94.35m29.05-49l-6.05-2.1V81.6l6.05.95v-37.2m-29.05-6.9L.5 36.7v40.45l5.25.8v-39.5m79.55-21l-3.45-2v32.4l3.45 1.45V17.45M289.7 139.9l-.15-.05v29l3.5 1.25v-29.75l-3.35-.45m-.15-35.45l-4.05.3V130l4.05.35v-25.9m13-1.75v-2.3l-2.7.3v30.6l2.7.25V102.7m6.45-.65l-2.7.3v29.55l2.7.25v-30.1m6.6-42.1l-3.25 1.1V88.5l3.25-.5V59.95m-15.75-41.2V17.35l-3.4 2v31.3l3.4-1.45V18.75m58 256.15l-5.45-4.15v34.55l5.45 4.95V274.9m-20.1-71.1v-4.45l-3.4-1.65v39.25l3.4 2.15v-35.3m17.5 12.75l-6.05-2.95v32.75l6.05 3.85v-33.65m45.6 19.95l-4.35-1.95v41.75l4.35 2.75V236.5m-22.6-14.65l-3.75-1.7v42.2l3.75 2.4v-42.9m-3.75-124.9v41.2l9 .85V96l-9 .95M337.75 54.3V49.65l-3.4 1.2V85.1l3.4-.55V54.3m22.35-12.35l-4.85 1.65v38.2l4.85-.8V41.95m36.4-12.55l-4.55 1.55v45l4.55-.7V29.4M360.1-3h-4.85v28.7l4.85-2.05V-3m-70.55 0h-4.05v13.65l4.05-2.95V-3m13 1.2l1.7-1.2h-1.7v1.2m-220.7-.4V-3h-1.1l1.1.8M-12.5-3h-3.35v9.3l3.35 1.4V-3m36.4 0H19v24.15l4.9 2.1V-3z"
                    />
                    <path
                        fill="#EABFF5"
                        d="M312.15 240.45v28.45l2.25 2v-28.75l-2.25-1.65v-.05z"
                    />
                    <path
                        fill="#8C8882"
                        d="M307.4 236.9v.05h9.85l-6.35-4.5h-9.5l6 4.45m0 1.9l4.75 3.85v-2.2.05l2.25 1.65 4 3v-6.45h-11v.1m-13.35-18.3h-8.55l3.15 2.35 4.5 3.4 3.05 2.25v-2.05l2.7 2v-1.6h.05l2.45 1.55v.05h3.85l-11.2-7.95m-306.1 72.7l-3.8 2.7v11.55l5.6-4.25 8-6.05 5.2-3.95h-15M3 285.7l6.4-4.3v6.9l6.75-5.1 3.85-2.9 4.35-3.3H11l-12.4 8.7H3m35.25-24.4v5.2l6-4.55 6.4-4.85h-11.4l-20.6 14.5h5.75l4-3 9.85-7.3m28.35-20.85v4.7l2.4-1.8 3.85-2.9H66.6M84 232.1l4.1-3.05h-9.2l-12.3 8.7h9.85l.05-.05 4.15-3.1 3.35-2.5m4.2-5.65l.15-.1 2.1-1.45h-5.7l-2.2 1.55h5.65m2.3-1.6l-.05.05h.05v-.05m2.05-1.35v-.05l-.1.05h.1m0-1.45h-3.8l-2.05 1.45h3.8v-.15l2.05-1.3m6.95-1.55h-3v2.25l3-2.25m-4.8-2.7l-3.55 2.55h1.4l3.95-2.55h-1.8m-89.2 4.65l5.25-2.35h-26.6v11.85l5.6-2.5 8.5-3.8 7.25-3.2m5.25-5.45l4.75-2 7.45-3.1H2.65l-12.6 5.1h20.7M23 211.9v-.05l-.05.05H23m0-3.75v-.05l8.5-3.5H20.95l-8.9 3.55H23m16.5-.9h-8v3.55l8-3.55m11.1-4.95H45v2.5l5.6-2.5m-5.6-4.95h-5.85l-5.5 2.2h5.75l.1-.05 5.5-2.15m45.75-13.15H88.2v1.3l2.55-1.15v-.15m8.75-3.75h-4.25v1.9l4.25-1.9m-4.3-3.75h-4.1l-4.15 1.65h3.8v.15l4.45-1.8m-19.3 6.05L69 185.5h13.5v-.05l2.5-1.15 3.2-1.45v-.1H75.9m-9.3 5.3v7.1l2.9-1.3 2.25-1 4.75-2.15 6-2.65H66.6M.5 153.1l5.25-.7 3.75-.55 4-.55-22.2-.2-7.15-.05v4.35l3.35-.5 4.55-.6 4.7-.65 3.75-.55m23.4 1.15l4.85-.85 6.05-1.05 6.7-1.15-22.5.05v3.85l4.9-.85m-5.1-5.85l-3.8-.05-19.9.05-3.65.45q-.028.057-.15.15h22.95l4.55-.6m27.45-1.7l4.4-.6H29.3l-13.5 1.3h25.5l.2-.05 4.75-.65m26.45-1.35l4.8-.8 4.2-.7h-9v1.5m-3.4-5.85v2.3h12.35l.2-.05 3.45-.45 3.5-.5 3.4-.5 3.4-.45 3.9-.55H71.3l-2 .2m-2.7-.6l2.7-.2h-2.7v.2m251.8 58.65v-2.8h-6.05l3.25 1.5 2.8 1.3m-12.1-7.8l2.7 1.2 3.35 1.5h6.05v-2.7h-12.1m-6.45-2.9l2.7 1.2v-1.2l3.75 1.7v.05h12.1v-2.15l-2.8-1.1h-19.15l3.4 1.5m-3.4.4v-1.5h-3.35l3.35 1.5m-10.95-6.8l4.05 1.8 3.5 1.55.05.05h18.75l-8.55-3.4h-17.8m23.65-37.85l3.2.45 3.25.45 2.8.4v-1.3h-9.25m-2.65-3.5l2.5.3h9.4v-.3h-11.9m-6.65-2.85l.2.05h13.2l-3.5-.4h-13.1l3.2.35m0 5.05l2.7.35 3.75.55v-.9h-6.45m-10.3.6v-.65h-4.05l4.05.65m.15-2l3.35.45 3.4.45v-.9h-6.75m111.15 159.25h-11l4.3 3.2 6.7 5.1v-8.3m-32.45-16.5v.2l4.75 3.6 5.25 4v-1.55.05l7.25 5.25v-1.75l4.2 3v.05h10.4L382 282.65h-13.6m0-2.8v-.1h9.5l-7.65-5.4h-9.35l7.5 5.5m-7.5-5.55v.05-.05m-16.5-9.6l3.95 3 4.05 3.05 5.45 4.15v-5.05l3.05 2.3h6.2l-17.9-12.6h-14.75l4.45 3.65v-2.65l5.5 4.15m-6.65-60.9l4.75 2.1 6.7 3h25.6l-12.85-5.1h-24.2m63.1 30.75h-4.35l4.35 1.95v-1.95M383.5 223.9v.3l3.75 1.65 4.7 2.1 4.55 2.05h4.35v-6.1H383.5m17.2-4.7l-14.1-5.6h-37.4l6.05 2.95 4.85 2.35v-5.15l4.9 2.2 4.75 2.1 4.75 2.1 3.75 1.7v-5.2l5.25 2.5v.05h17.2m-66.35-21.65v.15l3.4 1.65.05.05h13.1l-4.6-1.85h-11.95m35.4-43.55v-1.4h-9.5l4.75.7 4.75.7m13.75-.05v-.75h-5.25l5.25.75m-5.25 1.3v-.5h-3.4l3.4.5m18.25-.45V153h-13l3.75.5 4.7.65 4.55.65m4.35-3.2v-.65h-4.35l4.35.65m-31.1-3.4h.55l4.2.6 1.7.25h24.65v-.85h-12.6l-17.05-2.1h-36.85l3.4.45 4.75.7 6.7.9 6.05.85 4.85.7h9.65v-1.5z"
                    />
                    <path
                        fill="#FFF"
                        d="M307.4 236.95v-.05.05m4.75 5.7l-4.75-3.85v25.8l4.75 4.3v-26.25m-296 40.55l-6.75 5.1v38l6.75-6.1v-37m56.75-41.4v-1.4l-.05.05-3.85 2.9v29l3.9-3.5V241.8m-27.9-37v-7.45l-5.5 2.15V244l5.5-3.5v-35.7m31.5-14.1l-4.75 2.15v30.6l4.75-3.05v-29.7M5.75 152.4l-5.25.7v50.1l5.25-1.9v-48.9m44.9-6.3l-4.4.6v39.95l4.4-1.55v-39m44.95-6.25l-3.4.45v29.75l3.4-1.25v-28.95m-13.75 1.95v-.05l-.2.05h.2m-4.35 2.75v30.8l4.35-1.55v-30l-.15.05-4.2.7m234.85 50.2v-2.3l-3.35-1.5v29.75l3.35 2.15v-28.1m3.25-51.25l-3.25-.45v34.05l3.25 1.15V143.5m45.3 130.85V313l7.5 6.8v-39.95l-7.5-5.5m-18.4-68.45l-4.75-2.1v35.3l4.75 3v-36.2m44.75 19.95l-3.75-1.65v43.85l3.75 2.4v-44.6m-12.75-5.7l-4.75-2.1v41.3l4.75 3v-42.2m-14.25-67.55l-.15-.05v41.8l4.9 1.8V153.3l-4.75-.7z"
                    />
                    <path
                        fill="#837F52"
                        d="M307.4 236.95v1.75h11v-.95l-1.15-.8h-9.85z"
                    />
                    <path
                        fill="#838CC9"
                        d="M296.2 228.5l-3.05-2.25v25.45l3.05 2.8v-26z"
                    />
                    <path
                        fill="#D4D4D4"
                        d="M293.15 226.25l-4.5-3.4v24.8l4.5 4.05v-25.45m85.25 62.65V328.85l7.25 6.55v-41.2l-7.25-5.25v-.05z"
                    />
                    <path
                        fill="#B8B480"
                        d="M301.4 232.45v-.05 26.75l6 5.45V236.9l-6-4.45z"
                    />
                    <path
                        fill="#460000"
                        d="M301.4 228.45v4h9.5l-5.65-4h-3.85z"
                    />
                    <path
                        fill="#F5D5BD"
                        d="M298.9 228.45l-2.7-2v28.05l2.7 2.4v-28.45z"
                    />
                    <path
                        fill="#770202"
                        d="M301.4 228.4l-2.45-1.55h-.05v30.05l2.5 2.25V228.4z"
                    />
                    <path
                        fill="#F7D566"
                        d="M-10.25 344.1v-40.9l-5.6 4.25v41.75l5.6-5.1z"
                    />
                    <path
                        fill="#547AEC"
                        d="M-2.25 336.85v-39.7l-8 6.05v40.9l8-7.25z"
                    />
                    <path
                        fill="#1A8A37"
                        d="M44.25 294.8v-32.85l-6 4.55v33.7l6-5.4z"
                    />
                    <path
                        fill="#409EC9"
                        d="M50.65 289v-31.9l-6.4 4.85v32.85l6.4-5.8z"
                    />
                    <path
                        fill="#626B87"
                        d="M24.35 277l.05-.05v-5.35h-5.75L11 277h13.35z"
                    />
                    <path
                        fill="#82B4AD"
                        d="M24.4 276.95l-.05.05-4.35 3.3v36.45l4.4-4v-35.8z"
                    />
                    <path
                        fill="#CBCBCB"
                        d="M20 280.3l-3.85 2.9v37l3.85-3.45V280.3z"
                    />
                    <path
                        fill="#A2B684"
                        d="M3 293.15l-.05.05-5.2 3.95v39.7L3 332.1v-38.95z"
                    />
                    <path
                        fill="#505646"
                        d="M3 293.15v-7.45h-4.4l-10.65 7.5h15l.05-.05z"
                    />
                    <path
                        fill="#656D59"
                        d="M9.4 281.4L3 285.7V332.1l6.4-5.8v-44.9z"
                    />
                    <path
                        fill="#828EB4"
                        d="M28.4 268.6l-4 3v41.15l4-3.6V268.6z"
                    />
                    <path
                        fill="#CDAA8F"
                        d="M38.25 266.5v-5.2l-9.85 7.3v40.55l9.85-8.95v-33.7z"
                    />
                    <path
                        fill="#646464"
                        d="M76.5 237.7v27.9l4.15-3.75V234.6l-4.15 3.1z"
                    />
                    <path
                        fill="#BCC954"
                        d="M76.5 237.7l-.05.05h.05v-.05m0 1.4l-3.6 2.7v27.05l3.6-3.25v-26.5z"
                    />
                    <path
                        fill="#F3C788"
                        d="M69 243.35l-2.4 1.8v29.4l2.4-2.2v-29z"
                    />
                    <path
                        fill="#A8A49D"
                        d="M66.6 239.1v1.35h6.25l.05-.05v1.4l3.6-2.7h-9.9m25.95-17.05v-1.55h-.25l.25-.15h-1.4l-2.4 1.7h3.8m-1.8-43.7h-3.8l-11.05 4.4h12.3V184.2h2.55V178.35z"
                    />
                    <path
                        fill="#484848"
                        d="M66.6 237.75v1.35h9.9v-1.35h-9.9z"
                    />
                    <path
                        fill="#EC5454"
                        d="M84 258.8v-26.7l-3.35 2.5v27.25L84 258.8z"
                    />
                    <path
                        fill="#84CD65"
                        d="M99.5 244.8v-24.3l-3 2.25-.25 25 3.25-2.95z"
                    />
                    <path
                        fill="#CD9365"
                        d="M88.15 229l-.05.05-4.1 3.05v26.7l4.15-3.75V229z"
                    />
                    <path
                        fill="#323764"
                        d="M88.35 228.85v-2.5l-.15.1h-5.65l-3.65 2.6h9.2l.05-.05.2-.15z"
                    />
                    <path
                        fill="#404680"
                        d="M90.5 224.9h-.05l-2.1 1.45v2.5l-.2.15v26.05l2.35-2.1V224.9z"
                    />
                    <path
                        fill="#606283"
                        d="M90.45 224.9l.05-.05v-1.35h-3.8l-1.95 1.4h5.7z"
                    />
                    <path
                        fill="#8488BB"
                        d="M92.45 223.5l.1-.05v-1.4l-2.05 1.3v29.6l2.25-2.05-.2-27.4h-.1z"
                    />
                    <path
                        fill="#4F2E0D"
                        d="M92.55 220.5v-.15l-.25.15h.25M39.5 199.55v-.05l-.1.05h.1m260.35-63.25h.2l-.2-.05v.05m37.9 63.05v.05h.05l-.05-.05z"
                    />
                    <path
                        fill="#D9D5CD"
                        d="M92.55 220.35V223.5l.2 27.4 3.5-3.15.25-25v-4.95l-3.95 2.55z"
                    />
                    <path
                        fill="#FAF285"
                        d="M-1.75 225.65l-8.5 3.8v46.05l8.5-5.4v-44.45z"
                    />
                    <path
                        fill="#E2E2E2"
                        d="M-10.25 229.45l-5.6 2.5v47.1l5.6-3.55v-46.05z"
                    />
                    <path
                        fill="#BFBFBF"
                        d="M5.5 265.5v-43.05l-7.25 3.2v44.45l7.25-4.6M382 282.65l-4.1-2.9h-9.5v2.9H382z"
                    />
                    <path
                        fill="#D91919"
                        d="M10.75 220.1l-5.25 2.35v43.05l5.25-3.3v-42.1z"
                    />
                    <path
                        fill="#6778AD"
                        d="M10.75 220.1V217h-20.7l-5.9 2.4v.7h26.6z"
                    />
                    <path
                        fill="#8498D4"
                        d="M15.5 215l-4.75 2v45.2l4.75-3V215z"
                    />
                    <path
                        fill="#D4DFFF"
                        d="M39.5 207.25l-8 3.55v38.25l8-5.05v-36.75z"
                    />
                    <path
                        fill="#EED6C0"
                        d="M23 211.9h-.05L15.5 215v44.2l7.5-4.75V211.9z"
                    />
                    <path
                        fill="#BE97E5"
                        d="M22.95 211.9l.05-.05v-3.7H12.05l-9.4 3.75h20.3z"
                    />
                    <path
                        fill="#D5AAFF"
                        d="M31.5 207.25v-2.65l-8.5 3.5V254.45l8.5-5.4v-41.8z"
                    />
                    <path
                        fill="#D2D2D2"
                        d="M39.5 207.25v-7.7h-5.85l-12.7 5.05H31.5v2.65h8z"
                    />
                    <path
                        fill="#7DC6BC"
                        d="M50.65 202.3h-.05l-5.6 2.5v35.7l5.65-3.55V202.3z"
                    />
                    <path
                        fill="#FFEF80"
                        d="M82.5 188.05l-6 2.65v29.7l6-3.85v-28.5z"
                    />
                    <path
                        fill="#EEE6C0"
                        d="M88.2 185.5h-.05l.05 27.4 2.55-1.6v-26.95l-2.55 1.15z"
                    />
                    <path
                        fill="#AFF8FF"
                        d="M88.2 184.2v-1.35L85 184.3v30.65l3.2-2.05-.05-27.4h.05v-1.3z"
                    />
                    <path
                        fill="#005DFF"
                        d="M85 184.3l-2.5 1.15v31.1l2.5-1.6V184.3z"
                    />
                    <path
                        fill="#A69181"
                        d="M99.5 180.45l-4.25 1.9v26.05l4.25-2.7v-25.25z"
                    />
                    <path
                        fill="#C6C6C6"
                        d="M95.25 176.65l-.05.05-4.45 1.8v32.8l4.5-2.9v-31.75z"
                    />
                    <path
                        fill="#FFAAE2"
                        d="M71.75 192.85l-2.25 1v31.05l2.25-1.45v-30.6z"
                    />
                    <path
                        fill="#D7D7D7"
                        d="M69.5 193.85l-2.9 1.3v31.6l2.9-1.85v-31.05z"
                    />
                    <path
                        fill="#0550D2"
                        d="M66.6 186.45v1.6h15.9v-2.55H69l-2.4.95z"
                    />
                    <path
                        fill="#D7D580"
                        d="M-3.25 153.65l-4.7.65v51.95l4.7-1.7v-50.9z"
                    />
                    <path
                        fill="#D2B783"
                        d="M-7.95 154.3l-4.55.6v53l4.55-1.65V154.3z"
                    />
                    <path
                        fill="#E0DDC9"
                        d="M-12.5 154.9l-3.35.5v53.7l3.35-1.2v-53z"
                    />
                    <path
                        fill="#A4CCCD"
                        d="M.5 203.2v-50.1l-3.75.55v50.9L.5 203.2z"
                    />
                    <path
                        fill="#DEDEDE"
                        d="M34.8 152.35v38.45l6.7-2.4v-37.2l-6.7 1.15z"
                    />
                    <path
                        fill="#DEC9E0"
                        d="M9.5 151.85l-3.75.55v48.9l3.75-1.35v-48.1m79.3-11.05l-3.5.5v31.25l3.5-1.3V140.8z"
                    />
                    <path
                        fill="#B1B1B1"
                        d="M13.5 151.3l.75-.1V149H-8.7v2.1l22.2.2z"
                    />
                    <path
                        fill="#B6976B"
                        d="M14.25 151.2l-.75.1-4 .55v48.1l4.75-1.7V151.2m63.25-50.35v-1l-4.8-.5v33.1l4.8-.4v-31.2z"
                    />
                    <path
                        fill="#5C9C61"
                        d="M34.8 152.35l-6.05 1.05V193l6.05-2.2v-38.45m54-49.2l-3.5-.35v28.5l3.5-.3v-27.85m200.75 38.75l-4.05-.65v26.15l4.05 1.45V141.9m80.2-48.9l-4.75.5v43.8l4.75.4V93z"
                    />
                    <path
                        fill="#E0C9C9"
                        d="M28.75 153.4l-4.85.85v40.5l4.85-1.75v-39.6m283.6-10.35l-3.2-.45-.15-.05v33.35l3.35 1.2v-34.05z"
                    />
                    <path
                        fill="#D0D0D0"
                        d="M19 148.35l-.2.05-4.55.6v49.25L19 196.5v-48.15M41.5 97.2v-1.4l-6.7-.7v40.85l6.7-.65V97.2M28.75 43.25L23.9 41.6v39.25l4.85.75V43.25M95.6 68.4l-3.4-1.15v24.4l3.4.5V68.4m197.45 115.4l-3.5-1.55v26.05l3.5 2.2V183.8m13.25-51.9v-29.55l-3.75.35v28.85l3.75.35z"
                    />
                    <path
                        fill="#1E8185"
                        d="M41.5 147.35l-.2.05H15v.95l3.8.05.2-.05v2.9l22.5-.05v-3.85z"
                    />
                    <path
                        fill="#2AACB1"
                        d="M46.25 146.7l-4.75.65V188.4l4.75-1.75V146.7z"
                    />
                    <path
                        fill="#9BC99F"
                        d="M92.2 140.3l-3.4.5v30.45l3.4-1.2V140.3z"
                    />
                    <path
                        fill="#D9B979"
                        d="M81.85 141.75v32.05l3.45-1.25V141.3l-3.45.45z"
                    />
                    <path
                        fill="#E5E4B2"
                        d="M72.7 145.35v-2.3l-3.4.45v34.8l3.4-1.2v-31.75z"
                    />
                    <path
                        fill="#7FA3B4"
                        d="M77.5 144.55l-4.8.8v31.75l4.8-1.75v-30.8z"
                    />
                    <path
                        fill="#8C7444"
                        d="M69.3 141.8v1.7l3.4-.45v.8h9l.15-.05v-2H69.3z"
                    />
                    <path
                        fill="#D97979"
                        d="M69.3 139.5v-.8l-2.7.2v40.4l2.7-1v-38.8z"
                    />
                    <path
                        fill="#7BBDD2"
                        d="M85.3 101.6l-3.45-.35v30.4l3.45-.35v-29.7z"
                    />
                    <path
                        fill="#BBB960"
                        d="M81.85 101.25l3.45.35v1.2l3.5.35v-2.05h-8.85l1.9.15z"
                    />
                    <path
                        fill="#AAA"
                        d="M95.6 101.85v28.5l3.9-.35v-27.75l-3.9-.45v.05z"
                    />
                    <path
                        fill="#629DBF"
                        d="M95.6 102.9l-3.4-.3v28.1l3.4-.35V102.9z"
                    />
                    <path
                        fill="#E7E58E"
                        d="M92.2 102.6v-1.15l-3.4-.35V131l3.4-.3v-28.1m286.05 52.65l-3.4-.5-.35-.05v44.85l3.75 1.35v-45.65z"
                    />
                    <path
                        fill="#919191"
                        d="M92.2 101.85v.75l3.4.3v-1.05h-3.4M293.05 65.9v25.7l3.4-.55v-26.3l-3.4 1.15z"
                    />
                    <path
                        fill="#F7AB38"
                        d="M69.3 132.8l3.4-.35v-33.1l-3.4-.4v33.85z"
                    />
                    <path
                        fill="#83735D"
                        d="M79.95 101.1l-2.45-.25v31.2l4.35-.4v-30.4l-1.9-.15z"
                    />
                    <path
                        fill="#956B2A"
                        d="M69.3 98.95l-2.7-.35v34.45l2.7-.25V98.95m-18.65-.9l-4.4-.4v37.2l4.05-.35h.35V98.05z"
                    />
                    <path
                        fill="#807159"
                        d="M-7.95 90.45l-4.55-.5v50.35l4.55-.45v-49.4z"
                    />
                    <path
                        fill="#427577"
                        d="M-3.25 93.4V91l-4.7-.55v49.4l4.7-.4V93.4z"
                    />
                    <path
                        fill="#CDC3B3"
                        d="M.5 139.1V93.8l-3.75-.4v46.05l3.75-.35m369.25-1.4l4.75.45v-39.2l-4.75.45v38.3z"
                    />
                    <path
                        fill="#B4C9E5"
                        d="M23.9 93.95L19 93.4v44l4.9-.45v-43z"
                    />
                    <path
                        fill="#A8A77A"
                        d="M34.8 95.1l-6.05-.65v42.05l6.05-.55V95.1z"
                    />
                    <path
                        fill="#E0886F"
                        d="M14.25 98l-4.75-.35v40.6l4.75-.4V98z"
                    />
                    <path
                        fill="#395172"
                        d="M14.25 92.95v44.9l4.75-.45v-44l-4.75-.5v.05z"
                    />
                    <path
                        fill="#F5E5AF"
                        d="M9.5 97.65v-2.9l-3.75-.4v44.25l3.75-.35v-40.6z"
                    />
                    <path
                        fill="#23334A"
                        d="M.5 93.8l5.25.55 3.75.4v2.9l4.75.35v-5.05h-17.5v.45l3.75.4z"
                    />
                    <path
                        fill="#9F7941"
                        d="M-3.25 33.8v-1.55l-4.7-1.65v45.2l4.7.75V33.8z"
                    />
                    <path
                        fill="#8E3D3D"
                        d="M-12.5 30.7l-3.35-1.15v45l3.35.5V30.7z"
                    />
                    <path
                        fill="#AA9B85"
                        d="M-12.5 29.05v46l4.55.75V30.6l-4.55-1.55z"
                    />
                    <path
                        fill="#85755F"
                        d="M-15.85 29.05v.5l3.35 1.15v-1.65h-3.35z"
                    />
                    <path
                        fill="#856363"
                        d="M41.5 83.65v-36l-6.7-2.3v37.2l6.7 1.1z"
                    />
                    <path
                        fill="#A8906C"
                        d="M46.25 51.35l-4.75-1.6v33.9l4.75.75V51.35z"
                    />
                    <path
                        fill="#366B2F"
                        d="M50.65 52.85l-4.4-1.5V84.4l4.4.7V52.85z"
                    />
                    <path
                        fill="#585858"
                        d="M14.25 43.35L9.5 41.8v36.75l4.75.75V43.35m67.6 4.5v-32.4l-4.35-2.5V46l4.35 1.85m214.6-28.5l-3.4 1.95v30.8l3.4-1.45v-31.3m95.5 13.25l-4.7 1.6v42.5l4.7-.75V32.6M374.5-3h-4.75v22.55l4.75-2.05V-3M46.25-3H41.5v33.75l4.75 2V-3z"
                    />
                    <path
                        fill="#769F9B"
                        d="M19 39.9V80.05l4.9.8V41.6L19 39.9z"
                    />
                    <path
                        fill="#DEBD51"
                        d="M14.7 39.9l-.45-.15V79.3l4.75.75v-38.7l-4.3-1.45z"
                    />
                    <path fill="#567B78" d="M19 39.9h-4.3l4.3 1.45V39.9z" />
                    <path
                        fill="#BB9D3D"
                        d="M9.5 39.9v1.9l4.75 1.55V39.9H9.5z"
                    />
                    <path
                        fill="#54596D"
                        d="M.5 35.35v-.25l-3.75-1.3v42.75l3.75.6V35.35M92.2 24.2v-2.75l-3.4-1.95v31.25l3.4 1.45v-28m220.15-14.05L309 12.1v33.25l3.35-1.4v-33.8m56.85 30.1l-4.2 1.4v38.6l4.75-.75V40.05l-.55.2M302.55-1.8V-3h-2.7V.2l2.7-2z"
                    />
                    <path
                        fill="#131C2A"
                        d="M5.75 35.35H.5v1.35l5.25 1.75v-3.1z"
                    />
                    <path
                        fill="#1E2C41"
                        d="M9.5 36.6l-3.75-1.3v42.65l3.75.6V36.6z"
                    />
                    <path
                        fill="#9C712F"
                        d="M72.7 59.5v-1l-6.1-2.1v31.15l6.1.95v-29z"
                    />
                    <path
                        fill="#545454"
                        d="M77.5 61.15l-2.95-1-1.85-.65v29l4.8.8V61.15m14.7 6.1V66.1l-3.4-1.15V91.1l3.4.55v-24.4m250.3-14.5l-4.75 1.55v30.25l4.75-.75V52.75z"
                    />
                    <path
                        fill="#707070"
                        d="M77.5 61.15v-1h-2.95l2.95 1M302.25 17.4h-2.4v1.35l2.4-1.35z"
                    />
                    <path
                        fill="#858585"
                        d="M81.85 90V61.65l-4.35-1.5V89.3l4.35.7m211.2 12.65l-3.5.3v27.4l3.5.35v-28.05m107.8-10.8l-4.35.45v47.9l4.35.4V91.85m-45.6 2.7v41.85l4.85.45v-42.8l-4.85.5m0-50.95l-6.05 2.1v37.05l6.05-.95V43.6z"
                    />
                    <path
                        fill="#627260"
                        d="M85.3 62.85l-3.45-1.2V90l3.45.55v-27.7M309 99.7v32.45l3.35.35V99.35l-3.35.35m74.5-62l-5.25 1.7v38.75l5.25-.85V37.7z"
                    />
                    <path
                        fill="#7E7567"
                        d="M99.5 67.75l-3.9-1.35v25.75l3.9.65V67.75z"
                    />
                    <path
                        fill="#695E4E"
                        d="M92.2 67.25l3.4 1.15v-2h-3.4v.85z"
                    />
                    <path
                        fill="#818FC6"
                        d="M88.8 64.05l-3.5-1.2v27.7l3.5.55V64.05z"
                    />
                    <path fill="#353333" d="M77.5 12.95h-2.8l2.8 1.55v-1.55z" />
                    <path
                        fill="#A89C70"
                        d="M72.7 12.95v31L77.5 46V14.5l-2.8-1.55-2-1.15v1.15z"
                    />
                    <path
                        fill="#8A7F59"
                        d="M72.6 12.95h.1V11.8h-1.95l1.85 1.15z"
                    />
                    <path
                        fill="#2A1704"
                        d="M72.7 12.95h-.1l.1.05v-.05M400.85 149.7h-.4l.4.05v-.05z"
                    />
                    <path
                        fill="#7E694F"
                        d="M69.3 10.85V8.2l-2.7-1.55V41.4l2.7 1.15v-31.7M289.55 24.6l-4.05 2.3v28.4l4.05-1.75V24.6z"
                    />
                    <path
                        fill="#5D6444"
                        d="M70.75 11.8l-1.45-.95v31.7l3.4 1.4V13l-.1-.05-1.85-1.15z"
                    />
                    <path
                        fill="#B69E4E"
                        d="M95.6 26.05l-2.1-1.1-1.3-.75v28l3.4 1.45v-27.6M14.25-3H9.5v20.1l4.75 2V-3z"
                    />
                    <path
                        fill="#953B3B"
                        d="M99.5 27.05l-3.9-2.1V53.65l3.9 1.65V27.05M365-3h-4.9v26.65l4.9-2.1V-3M34.8-3h-6.05v28.3l6.05 2.6V-3z"
                    />
                    <path fill="#742929" d="M95.6 24.95h-2.1l2.1 1.1v-1.1z" />
                    <path
                        fill="#A15323"
                        d="M88.8 19.5l-3.5-2.05V49.3l3.5 1.45V19.5M-7.95-3h-4.55V7.7l4.55 1.95V-3z"
                    />
                    <path
                        fill="#F0EF9F"
                        d="M315.6 196.25l-3.25-1.5v28.1l3.25 2.1v-28.7z"
                    />
                    <path
                        fill="#DFEED6"
                        d="M318.4 197.55l-2.8-1.3v28.7l2.8 1.8v-29.2z"
                    />
                    <path
                        fill="#BBB2A3"
                        d="M309 190.95l-2.7-1.2V219l2.7 1.7v-29.75z"
                    />
                    <path
                        fill="#E7E7E7"
                        d="M312.35 192.45v2.3h6.05v-2.3h-6.05z"
                    />
                    <path
                        fill="#6EB474"
                        d="M306.3 188.6v1.15h12.1v-1.15h-12.1z"
                    />
                    <path
                        fill="#94D79A"
                        d="M302.55 186.85v29.75l3.75 2.4v-30.45l-3.75-1.7m89.4-32.7l-4.7-.65v50.65l4.7 1.7v-51.7z"
                    />
                    <path
                        fill="#EED8AF"
                        d="M302.55 188.05l-2.7-1.2v28l2.7 1.75v-28.55z"
                    />
                    <path
                        fill="#B5D4F0"
                        d="M296.45 185.75v26.95l3.4 2.15v-28l-3.4-1.5v.4z"
                    />
                    <path
                        fill="#F5A4A4"
                        d="M293.1 185.75l-.05-.05v24.8l3.4 2.2v-25.45l-3.35-1.5m-.05-1.9h.05l-.05-.05v.05z"
                    />
                    <path
                        fill="#B4B4B4"
                        d="M293.1 183.85h-.05v1.85l.05.05h3.35v-.4h19.15l-3.75-1.5H293.1z"
                    />
                    <path
                        fill="#AF9882"
                        d="M289.55 182.25l-4.05-1.8v25.25l4.05 2.6v-26.05M383.5 153V202.8l3.75 1.35V153.5l-3.75-.5z"
                    />
                    <path
                        fill="#5D8FAD"
                        d="M306.3 142.2l-3.75-.55v31.9l3.75 1.35v-32.7z"
                    />
                    <path
                        fill="#B17753"
                        d="M318.4 143.9l-2.8-.4v34.75l2.8 1.05v-35.4z"
                    />
                    <path
                        fill="#B85E26"
                        d="M309 142.55l.15.05h9.25v-3.2H309v3.15z"
                    />
                    <path
                        fill="#DE7E43"
                        d="M306.3 139.1V174.9l2.7 1v-36.5l-2.5-.3h-.2z"
                    />
                    <path
                        fill="#DECEE7"
                        d="M296.45 140.8l-3.4-.45v29.75l3.4 1.25V140.8z"
                    />
                    <path
                        fill="#E9D998"
                        d="M302.55 141.65l-2.7-.35v31.25l2.7 1v-31.9m46.65 48.8l6.05 2.15V149l-6.05-.85v42.3m47.3-98.15l-4.55.45v47l4.55.45V92.3z"
                    />
                    <path
                        fill="#77876D"
                        d="M299.85 136.3v5h6.45v-2.2h12.1v-2.25l-5.15-.55H299.85z"
                    />
                    <path
                        fill="#A1AF98"
                        d="M296.65 135.9h-.2v35.45l3.4 1.2v-36.3l-3.2-.35z"
                    />
                    <path
                        fill="#463C34"
                        d="M141 181.5h4.4V159H141v22.5m20.4-22.5H160v22.5h1.4V159m-42.2 0v22.5h5.8V159h-5.8m54.4 0h-3.8v22.5h3.8V159m16 0h-2v22.5h2V159m73.8 0h-2v22.5h2V159m-15.4 0h-2v22.5h2V159m-26 22.5h2V159h-2v22.5m16.2-22.5H234v22.5h4.2V159m-37 0v22.5h2V159h-2m-51.8-34H143v22.25h6.4V125m-26.8 22.25V125h-2v22.25h2M141 125h-3.4v22.25h3.4V125m32.6 22.25V125h-1.8v22.25h1.8M165.8 125h-2.4v22.25h2.4V125m12 0h-2.2v22.25h2.2V125m90 0h-2v22.25h2V125m-6.4 0v22.25h2V125h-2m-7.6 22.25V125H250v22.25h3.8m-56-22.25h-2.2v22.25h2.2V125m36.2 22.25V125h-3.6v22.25h3.6M222 125v22.25h2V125h-2m-3.4 0h-4.2v22.25h4.2V125m-64.8-32.95h-2.4v21.05h2.4V92.05m-6.4 0h-2v21.05h2V92.05m-28.2 0h-2v21.05h2V92.05m72.4 0h-2v21.05h2V92.05m-23.8 0h-4.4v21.05h4.4V92.05m7.8 0h-2v21.05h2V92.05M131 58.5h-4V81h4V58.5m20.4 0h-2V81h2V58.5m18.4 0h-2V81h2V58.5m5.8 0h-2V81h2V58.5m-60.6-12h5.6V27.05H115V46.5m38.8 0h2V27.05h-2V46.5m12-19.45h-2.4V46.5h2.4V27.05m4 .05l-2-.05V46.5h2V27.1m33.4 64.95h-2v21.05h2V92.05M236 92h-2v21.1h2V92m-5.6 0h-2v21.1h2V92m-8.4 0h-1.4v21.1h1.4V92m47.8 0h-4v21.1h4V92M246 92h-2.4v21.1h2.4V92m-34.4-33.5h-2V81h2V58.5m26.6 0h-5.8V81h5.8V58.5M261.4 81h2V58.5h-2V81m-7.6-22.5H250V81h3.8V58.5m4.2 0h-2.2V81h2.2V58.5m-25.6-31.4v19.4h1.6V27.1h-1.6m-22.8 0h-2v19.4h2V27.1m12.4 0h-5.6v19.4h5.6V27.1m49.8 0h-2v19.4h2V27.1m-18 19.4V27.1H252v19.4h1.8m6.2-19.4h-2v19.4h2V27.1M246-3h-4.4v16.25h4.4V-3m19.8 0h-2.4v16.25h2.4V-3M250-3h-2v16.25h2V-3m8 0h-2.2v16.25h2.2V-3m-54.8 0h-2v16.25h2V-3m29.2 0h-6v16.25h6V-3m-16 0h-2v16.25h2V-3m4.2 0h-2v16.25h2V-3m-47 0h-3.8v16.25h3.8V-3m-51 0h-2v16.25h2V-3m33.2 0h-2v16.25h2V-3m4.2 0h-2v16.25h2V-3m-22.4 0h-2.2v16.25h2.2V-3z"
                    />
                    <path
                        fill="#2E2822"
                        d="M127 159h-2v22.5h2V159m10.6 0h-2.2v22.5h2.2V159m16.2 0h-6.4v22.5h6.4V159m-36.6 0H115v22.5h2.2V159m62.6 22.5h3.4V159h-3.4v22.5M250 159h-2v22.5h2V159m3.8 0H252v22.5h1.8V159m12 0h-2.4v22.5h2.4V159m6 0h-4v22.5h4V159m-30.2 0v22.5h2V159h-2m-21 0h-6.2v22.5h6.2V159m-13 0h-4.4v22.5h4.4V159m22.8 0h-2v22.5h2V159m-29.2 0h-3.4v22.5h3.4V159m-84-34H113v22.25h4.2V125m44.2 0h-5.6v22.25h5.6V125m-30.4 0h-2v22.25h2V125m56.6 0h-4.4v22.25h4.4V125m-17.8 0h-4v22.25h4V125m102 0h-2v22.25h2V125m-13.8 0h-2.2v22.25h2.2V125m-17.8 0v22.25h7.8V125h-7.8m-9.8 0h-2v22.25h2V125m-22.8 0h-2v22.25h2V125m4 0h-2v22.25h2V125m-50.2-32.95h-7.6v21.05h7.6V92.05m-26 0H127v21.05h8.4V92.05m52.2 0h-6.4v21.05h6.4V92.05m-48-33.55h-2V81h2V58.5m5.8 0H143V81h2.4V58.5m10.4 0h-2V81h2V58.5m-36.6 0V81h3.4V58.5h-3.4m-2 0H113V81h4.2V58.5M165.8 81V58.5h-4.4V81h4.4m9.8 0h7.6V58.5h-7.6V81m14-22.5h-4V81h4V58.5m-50-31.45V46.5h7.8V27.05h-7.8m-6.2 19.45h2V27.05h-2V46.5m54.2-19.4h-2v19.4h2V27.1m-14 0v19.4h9.6V27.1h-9.6M240.2 92h-2v21.1h2V92m-19.6 0l-11 .05v21.05h11V92m45.2 0h-2.4v21.1h2.4V92m-12 0H250v21.1h3.8V92m-33.2-11h7.8V58.5h-7.8V81m-15-22.5h-2.4V81h2.4V58.5m-4.4 0h-1.4V81h1.4V58.5M243.6 81V58.5h-2V81h2m28.2-22.5h-6V81h6V58.5m-43.4-31.4h-2v19.4h2V27.1m-25.2 19.4V27.1h-5.4v19.4h5.4m66.6-19.4h-6.4v19.4h6.4V27.1m-23.8 0h-2.4v19.4h2.4V27.1m6 0h-2v19.4h2V27.1M271.8-3h-4v16.25h4V-3m-10.4 0H260v16.25h1.4V-3m-23.2 0H236v16.25h2.2V-3m-40.4 0h-2.2v16.25h2.2V-3m-10.2 0h-4.4v16.25h4.4V-3m-7.8 0h-2v16.25h2V-3m-34.4 0H141v16.25h4.4V-3m8.4 0h-2.4v16.25h2.4V-3m-4.4 0h-2v16.25h2V-3m-16 0H129v16.25h4.4V-3M115-3h-2v16.25h2V-3z"
                    />
                    <path
                        fill="#383029"
                        d="M135.4 159H127v22.5h8.4V159m5.6 0h-3.4v22.5h3.4V159m6.4 0h-2v22.5h2V159m12.6 0h-6.2v22.5h6.2V159m-45 0h-3.6v22.5h3.6V159m4.2 0h-2v22.5h2V159m50.6 22.5V159h-8.4v22.5h8.4m10-22.5h-6.2v22.5h6.2V159m11.9 0h-2.1v22.5h2.1V159m-4.1 0h-4.4v22.5h4.4V159m64.4 0h-2v22.5h2V159m9.4 0h-7.6v22.5h7.6V159m-15.4 0h-2.4v22.5h2.4V159m21.8 0h-2v22.5h2V159m5.8 0h-1.8v22.5h1.8V159m-51.6 0h-1.4v22.5h1.4V159m-7.6 0h-6.8v22.5h6.8V159m27.2 0h-3.4v22.5h3.4V159m-7.6 0h-3.6v22.5h3.6V159m-5.6 0H224v22.5h4.4V159m-30.6 0h-4.05v22.5h4.05V159M113 125h-1.6v22.25h1.6V125m7.6 0h-3.4v22.25h3.4V125m35.2 22.25V125h-6.4v22.25h6.4M141 125v22.25h2V125h-2m-10 0v22.25h6.6V125H131m-2 0h-6.4v22.25h6.4V125m62.7 0h-4.1v22.25h4.1V125m-13.9 0v22.25h5.4V125h-5.4m-14.4 22.25V125h-2v22.25h2m8.4-22.25h-2v22.25h2V125m3.8 0h-2v22.25h2V125m98 22.25V125h-1.8v22.25h1.8M269.8 125h-2v22.25h2V125m-4 0h-2.4v22.25h2.4V125m-15.8 0h-2v22.25h2V125m11.4 0H258v22.25h3.4V125m-5.6 0h-2v22.25h2V125m-60.2 0h-1.85v22.25h1.85V125m32.8 0H224v22.25h4.4V125m11.8 0H234v22.25h6.2V125m-25.8 22.25V125h-2.8v22.25h2.8m-8.8 0V125h-7.8v22.25h7.8m4-22.25h-2v22.25h2V125m12.4 0h-3.4v22.25h3.4V125m-95-32.95h-7.8v21.05h7.8V92.05m18.4 0h-10v21.05h10V92.05m6 0h-4v21.05h4V92.05m-34.2 0h-5.8v21.05h5.8V92.05m46.2 21.05V92.05h-2v21.05h2m28.3-21.05h-.1v21.05h.1V92.05m-2.1 0h-2v21.05h2V92.05m-16 0h-5.8v21.05h5.8V92.05m7.6 0h-5.6v21.05h5.6V92.05M139.6 81h3.4V58.5h-3.4V81m-2-22.5H131V81h6.6V58.5m-10.6 0h-4.4V81h4.4V58.5m22.4 0h-4V81h4V58.5m4.4 0h-2.4V81h2.4V58.5m7.6 0h-5.6V81h5.6V58.5m-48.4 0h-1.6V81h1.6V58.5m6.2 0h-2V81h2V58.5m48.6 0h-2V81h2V58.5m5.8 0h-3.8V81h3.8V58.5m18.1 0h-2.1V81h2.1V58.5m-6.1 0h-2.4V81h2.4V58.5m-74.2-12h3.6V27.05h-3.6V46.5m36 0h6.4V27.05h-6.4V46.5m-14 0V27.05h-12.8V46.5h12.8m2 0h4.2V27.05h-4.2V46.5m56.3-19.4h-4.1v19.4h4.1V27.1m-6.1 0h-2.4v19.4h2.4V27.1m-22.2 19.4V27.05h-7.6V46.5h7.6m6.4 0h3.8V27.1h-3.8v19.4m-2-19.45h-2V46.5h2V27.05m75.8 86.05V92h-3.4v21.1h3.4M228.4 92H222v21.1h6.4V92m9.8 0H236v21.1h2.2V92m-4.2 0h-3.6v21.1h3.6V92m-24.4.05h-6.4v21.05h6.4V92.05m-8.4 0h-7.45v21.05h7.45V92.05m62.2-.05h-9.6v21.1h9.6V92m10.2 0h-3.8v21.1h3.8V92M250 92h-4v21.1h4V92m-40.4-33.5h-4V81h4V58.5m11 0h-9V81h9V58.5m11.8 0h-4V81h4V58.5m9.2 0h-3.4V81h3.4V58.5m-40.4 0V81h2V58.5h-2m-1.4 0h-6.05V81h6.05V58.5m50.2 0h-6.4V81h6.4V58.5m5.8 0h-2V81h2V58.5m5.6 0H258V81h3.4V58.5m12.2 0h-1.8V81h1.8V58.5m-7.8 0h-2.4V81h2.4V58.5m-68-31.4h-4.05v19.4h4.05V27.1m34.6 0h-4v19.4h4V27.1m-10.4 0v19.4h4.4V27.1H222m-12.4 0v19.4h6.8V27.1h-6.8m-2 0h-4.4v19.4h4.4V27.1m66 0h-1.8v19.4h1.8V27.1m-13.6 0v19.4h3.4V27.1H260m-16.4 19.4V27.1H234v19.4h9.6m6.4-19.4h-4v19.4h4V27.1m8 0h-4.2v19.4h4.2V27.1M263.4-3h-2v16.25h2V-3m4.4 0h-2v16.25h2V-3m5.8 0h-1.8v16.25h1.8V-3M248-3h-2v16.25h2V-3m7.8 0H250v16.25h5.8V-3m4.2 0h-2v16.25h2V-3m-33.6 0h-5.8v16.25h5.8V-3m9.6 0h-3.6v16.25h3.6V-3m5.6 0h-3.4v16.25h3.4V-3m-27.2 0h-11.2v16.25h11.2V-3m4.2 0h-2.2v16.25h2.2V-3m-23 0h-1.85v16.25h1.85V-3m5.6 0h-3.4v16.25h3.4V-3m-31.4 0H160v16.25h9.8V-3m13.4 0h-3.4v16.25h3.4V-3m8.5 0h-4.1v16.25h4.1V-3m-13.9 0h-4.2v16.25h4.2V-3M158-3h-2.2v16.25h2.2V-3m-6.6 0h-2v16.25h2V-3m-4 0h-2v16.25h2V-3M129-3h-6.4v16.25h6.4V-3m6.4 0h-2v16.25h2V-3m5.6 0h-3.4v16.25h3.4V-3m-28 0h-1.6v16.25h1.6V-3m7.6 0H115v16.25h5.6V-3z"
                    />
                    <path
                        fill="#BB9144"
                        d="M312.35 132.5l3.25.3V98.95l-3.25.4v33.15z"
                    />
                    <path
                        fill="#C6BE9B"
                        d="M299.85 100.7l-3.4.35V131l3.4.3v-30.6m83.65-66.8v43.4l3.75-.6V32.6l-3.75 1.3z"
                    />
                    <path
                        fill="#9C773F"
                        d="M293.05 101.4v29.3l3.4.3v-29.95l-3.4.35z"
                    />
                    <path
                        fill="#777"
                        d="M309 102.05v-1.65h-6.45v2.3l3.75-.35 2.7-.3z"
                    />
                    <path
                        fill="#836B3E"
                        d="M318.4 98.6l-2.8.35v33.85l2.8.25V98.6m19.35 47.95l-3.4-.45v39l3.4 1.2v-39.75z"
                    />
                    <path
                        fill="#5787A3"
                        d="M302.55 90.05l3.75-.6v-28.9l-3.75 1.3v28.2z"
                    />
                    <path
                        fill="#264C62"
                        d="M302.55 61.85l-2.7.95v27.7l2.7-.45v-28.2z"
                    />
                    <path
                        fill="#8B6A91"
                        d="M296.45 63.95v27.1l3.4-.55V62.8l-3.4 1.15z"
                    />
                    <path
                        fill="#6D6D6D"
                        d="M293.05 67.35l-3.5 1.15v23.65l3.5-.55V67.35z"
                    />
                    <path
                        fill="#7E2323"
                        d="M289.55 68.5l-4.05 1.35V92.8l4.05-.65V68.5z"
                    />
                    <path
                        fill="#5B6477"
                        d="M309 59.6l-2.7.95v28.9l2.7-.4V59.6z"
                    />
                    <path
                        fill="#7E6B4D"
                        d="M312.35 58.5v-.05L309 59.6v29.45l3.35-.55v-30z"
                    />
                    <path
                        fill="#544630"
                        d="M315.6 59.95V58.5h-3.25v2.55l3.25-1.1z"
                    />
                    <path
                        fill="#4A8C81"
                        d="M318.4 56.4l-2.8.95V88l2.8-.45V56.4z"
                    />
                    <path
                        fill="#807D69"
                        d="M302.55 48.05l3.75-1.55V15.1l-3.75 2.1v30.85z"
                    />
                    <path d="M302.55 17.2l-.3.2-2.4 1.35V49.2l2.7-1.15V17.2M355.25-3h-6.05v31.3l6.05-2.6V-3m-58.8 0h-3.4v8.15l3.4-2.5V-3M92.2-3h-3.4v5.85l3.4 2.45V-3M5.75-3H.5v16.25l5.25 2.25V-3m23 0H23.9v26.25l4.85 2.05V-3z" />
                    <path
                        fill="#6F9A6D"
                        d="M289.55 23.3v30.25l3.5-1.45V21.3l-3.5 2z"
                    />
                    <path
                        fill="#582424"
                        d="M318.4 6.65l-2.8 1.6v34.3l2.8-1.15V6.65z"
                    />
                    <path
                        fill="#B6AA55"
                        d="M309 13.55l-2.7 1.55v31.4l2.7-1.15v-31.8z"
                    />
                    <path
                        fill="#747474"
                        d="M315.6 8.25l-3.25 1.9v33.8l3.25-1.4V8.25z"
                    />
                    <path
                        fill="#F0EBAE"
                        d="M400.85 307.45l-6.7-5.1v40.75l6.7 6.1v-41.75m-52.5-39.75l-3.95-3v33.4l3.95 3.55V267.7z"
                    />
                    <path
                        fill="#565D3F"
                        d="M394.15 302.35l-4.3-3.2v-.05 40.1l4.3 3.9v-40.75z"
                    />
                    <path
                        fill="#998BBD"
                        d="M385.65 292.45v42.95l4.2 3.8v-43.75l-4.2-3z"
                    />
                    <path
                        fill="#6C618A"
                        d="M400.85 295.9l-.6-.4h-10.4v3.65h11v-3.25z"
                    />
                    <path
                        fill="#A7D9A9"
                        d="M378.4 290.45l-5.25-4v37.65l5.25 4.75v-38.4z"
                    />
                    <path
                        fill="#C96363"
                        d="M373.15 286.45l-4.75-3.6v36.95l4.75 4.3v-37.65z"
                    />
                    <path
                        fill="#74BCDE"
                        d="M360.9 274.3v.05h9.35l-3.15-2.2h-6.2v2.15z"
                    />
                    <path
                        fill="#F5BFD9"
                        d="M338.9 260.55v32.55l5.5 5v-33.4l-5.5-4.15z"
                    />
                    <path
                        fill="#BF9372"
                        d="M334.45 259.55l-.1-.1V289l4.55 4.1v-29.9l-4.45-3.65z"
                    />
                    <path
                        fill="#F0B39C"
                        d="M352.4 270.75l-4.05-3.05v33.95l4.05 3.65v-34.55z"
                    />
                    <path
                        fill="#95DAFA"
                        d="M360.9 272.15l-3.05-2.3v40.4l3.05 2.75V272.15z"
                    />
                    <path
                        fill="#72706E"
                        d="M361.95 203.8l-11.05-4.4h-13.15v4.4h24.2z"
                    />
                    <path
                        fill="#A7AAC9"
                        d="M349.2 213.6v-4.7l-6.7-3v36.2l6.7 4.25V213.6z"
                    />
                    <path
                        fill="#EEE6CB"
                        d="M360.1 218.9l-4.85-2.35v33.65l4.85 3.05V218.9z"
                    />
                    <path
                        fill="#CEDE9A"
                        d="M360.1 213.75v39.5l4.9 3.1v-40.4l-4.9-2.2z"
                    />
                    <path
                        fill="#777B9F"
                        d="M386.6 213.6l-11.8-4.7h-25.6v4.7h37.4z"
                    />
                    <path
                        fill="#A88C70"
                        d="M391.95 227.95l-4.7-2.1v44.6l4.7 2.95v-45.45z"
                    />
                    <path
                        fill="#E0A0D8"
                        d="M396.5 234.55V230l-4.55-2.05v45.45l4.55 2.9v-41.75z"
                    />
                    <path
                        fill="#B478AC"
                        d="M400.85 234.55V230h-4.35v4.55h4.35z"
                    />
                    <path
                        fill="#94BED7"
                        d="M369.75 218.05l-4.75-2.1v40.4l4.75 3v-41.3m-20.55-69.9l-6.7-.9V188l6.7 2.45v-42.3z"
                    />
                    <path
                        fill="#DECE9A"
                        d="M378.25 216.65v48.1l5.25 3.3v-48.9l-5.25-2.5z"
                    />
                    <path
                        fill="#BFB07C"
                        d="M400.85 219.25l-.15-.05h-17.2v4.7h17.35v-4.65z"
                    />
                    <path
                        fill="#F0C0C0"
                        d="M369.75 154l-4.75-.7v42.85l4.75 1.7V154z"
                    />
                    <path
                        fill="#9CC2AC"
                        d="M378.25 153.2V200.9l5.25 1.9v-48.85l-5.25-.75z"
                    />
                    <path
                        fill="#A37A52"
                        d="M396.5 154.8l-4.55-.65v51.7l4.55 1.65v-52.7z"
                    />
                    <path
                        fill="#F7E5E5"
                        d="M396.5 150.95V207.5l4.35 1.6v-57.5l-4.35-.65z"
                    />
                    <path
                        fill="#9C9C9C"
                        d="M400.45 149.7h.4v-.65H376.2l-1.7-.25v5.9l.35.05h3.4v-1.55h5.25v-.2h13v-2.05h4.35v-1.2l-.4-.05z"
                    />
                    <path
                        fill="#C8A0E0"
                        d="M360.1 152.55v-2.85l-4.85-.7v43.6l4.85 1.75v-41.8z"
                    />
                    <path
                        fill="#A37BBB"
                        d="M360.1 149.7v2.85l.15.05h9.5v-2.9h-9.65z"
                    />
                    <path
                        fill="#E78787"
                        d="M342.5 147.25l-4.75-.7v39.75l4.75 1.7v-40.75z"
                    />
                    <path
                        fill="#AFAFAF"
                        d="M370.3 148.2h-.55V197.85l4.75 1.7V148.8l-4.2-.6z"
                    />
                    <path
                        fill="#876839"
                        d="M365 93.5l-4.9.55v42.8l4.9.45V93.5z"
                    />
                    <path
                        fill="#57A396"
                        d="M391.95 92.75l-1.4.15-3.3.3v46.15l4.7.4v-47z"
                    />
                    <path
                        fill="#E9AE98"
                        d="M383.5 93.6V139l3.75.35V93.2l-3.75.4z"
                    />
                    <path
                        fill="#46804B"
                        d="M374.5 98.95v-2l9-.95v-2.4l3.75-.4 3.3-.3H370.9l-1.15.1v6.4l4.75-.45z"
                    />
                    <path
                        fill="#4895C4"
                        d="M349.2 97.6l-6.7.65v36.95l6.7.65V97.6z"
                    />
                    <path
                        fill="#A69883"
                        d="M355.25 97l-6.05.6v38.25l6.05.55V97z"
                    />
                    <path
                        fill="#7B7991"
                        d="M337.75 96.4l-3.4.4v37.7h.35l3.05.25V96.4z"
                    />
                    <path
                        fill="#7A75A3"
                        d="M342.5 95.95v2.3l6.7-.65 6.05-.6v-1.05H342.5z"
                    />
                    <path
                        fill="#9E99C9"
                        d="M342.5 95.9l-4.75.5v38.35l4.75.45V95.9z"
                    />
                    <path
                        fill="#6B6B6B"
                        d="M337.75 49.7v4.6l4.75-1.55V49.7h-4.75z"
                    />
                    <path
                        fill="#B1A085"
                        d="M349.2 45.7l-6.7 2.3v35.8l6.7-1.05V45.7z"
                    />
                    <path
                        fill="#1D544B"
                        d="M400.85 27.9l-4.35 1.5v45.85l4.35-.7V27.9z"
                    />
                    <path fill="#9F9673" d="M387.25 32.6v1.6l4.7-1.6h-4.7z" />
                    <path
                        fill="#232E46"
                        d="M378.25 39.4v-3.7L374.5 37v41.75l3.75-.6V39.4z"
                    />
                    <path
                        fill="#BF8121"
                        d="M365 41.65v-1.4l-4.9 1.7V81l4.9-.75v-38.6z"
                    />
                    <path fill="#9A6615" d="M369.2 40.25H365v1.4l4.2-1.4z" />
                    <path
                        fill="#98B899"
                        d="M369.75 38.6V79.5l4.75-.75V37l-4.75 1.6z"
                    />
                    <path
                        fill="#0F1625"
                        d="M383.5 35.7h-5.25v3.7l5.25-1.7v-2z"
                    />
                    <path fill="#292E23" d="M383.5-3h-5.25v18.9l5.25-2.2V-3z" />
                    <path
                        fill="#7A9C99"
                        d="M378.25-3h-3.75v20.5l3.75-1.6V-3z"
                    />
                    <path fill="#797979" d="M369.75-3H365v24.55l4.75-2V-3z" />
                    <path
                        fill="#AF9165"
                        d="M400.85-3h-4.35V8.15l4.35-1.85V-3z"
                    />
                    <path
                        fill="#AFAD65"
                        d="M396.5-3h-4.55v13.1l4.55-1.95V-3z"
                    />
                    <path fill="#21511E" d="M391.95-3h-4.7v15.1l4.7-2V-3z" />
                    <path
                        fill="#7E4D87"
                        d="M387.25-3h-3.75v16.7l3.75-1.6V-3z"
                    />
                    <path
                        fill="#8C8AAD"
                        d="M342.5-3h-4.75v36.2l4.75-2.05V-3z"
                    />
                    <path
                        fill="#A88"
                        d="M335.05-3l-.7.4v37.25l3.4-1.45V-3h-2.7z"
                    />
                    <path fill="#545E79" d="M349.2-3h-6.7v34.15l6.7-2.85V-3z" />
                    <path fill="#9F6E83" d="M293.05-3h-3.5V7.7l3.5-2.55V-3z" />
                    <path fill="#6D6654" d="M299.85-3h-3.4v5.65l3.4-2.45V-3z" />
                    <path fill="#793D67" d="M88.8-3h-3.5V.3l3.5 2.55V-3z" />
                    <path fill="#707955" d="M95.6-3h-3.4v8.3l3.4 2.5V-3z" />
                    <path fill="#23313F" d="M98.3-3h-2.7V7.8l2.7 1.95V-3z" />
                    <path
                        fill="#9F866E"
                        d="M99.5-3h-1.2V9.75l1.2.9V-3M81.85-3v.8L85.3.3V-3h-3.45z"
                    />
                    <path fill="#99A17F" d="M-3.25-3h-4.7V9.65l4.7 2V-3z" />
                    <path
                        fill="#7E775F"
                        d="M.5 13.25V-3h-3.75v14.65l3.75 1.6z"
                    />
                    <path fill="#7FA198" d="M41.5-3h-6.7v30.9l6.7 2.85V-3z" />
                    <path
                        fill="#A69179"
                        d="M49.95-3h-3.7v35.75l4.4 1.9V-2.6l-.7-.4z"
                    />
                    <path fill="#264124" d="M19-3h-4.75v22.1L19 21.15V-3z" />
                    <path fill="#D0C294" d="M9.5-3H5.75v18.5l3.75 1.6V-3z" />
                </g>
            </defs>
            <use
                xlinkHref="#PlaInd033__Symbol_3_0_Layer0_0_FILL"
                transform="translate(-15.85 -3)"
                id="PlaInd033__col1n"
            />
            <use xlinkHref="#PlaInd033__Layer7_0_FILL" />
            <use
                xlinkHref="#PlaInd033__Symbol_4_0_Layer0_0_FILL"
                transform="translate(-15.85 -3)"
                id="PlaInd033__col2n"
            />
            <use
                xlinkHref="#PlaInd033__Symbol_10_0_Layer0_0_FILL"
                transform="translate(-15.85 -3)"
                id="PlaInd033__col2d"
            />
            <use
                xlinkHref="#PlaInd033__Symbol_11_0_Layer0_0_FILL"
                transform="translate(-15.85 -3)"
                id="PlaInd033__col2s"
            />
            <use xlinkHref="#PlaInd033__Layer2_0_FILL" />
            <use xlinkHref="#PlaInd033__Layer2_1_FILL" />
            <use xlinkHref="#PlaInd033__Layer1_0_FILL" />
        </g></g>
    )
}
export default PlaInd033
